import React from 'react'
import { Button } from '@mui/material'

export default function PinkButton({startIcon,buttonTitle,onClick}) {
  return (
    <Button
            variant="contained"
            startIcon={startIcon?startIcon:""}
             onClick={onClick}
            sx={{
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: 600,
              textTransform: "none",
              backgroundColor: "#9D0385",
              px:3,
              "&:hover": {
                backgroundColor: "#9D0385",
              },
            }}
          >
            {buttonTitle}
          </Button>
  )
}
